import { render } from "./chatRightList.vue?vue&type=template&id=0bdabda6&scoped=true"
import script from "./chatRightList.vue?vue&type=script&lang=js"
export * from "./chatRightList.vue?vue&type=script&lang=js"

import "./chatRightList.vue?vue&type=style&index=0&id=0bdabda6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bdabda6"

export default script